let toastTimeout = null;

function showToast(message, type = 'success', duration = 3000) {
  const toast = document.querySelector('#toast');
  const icon = document.querySelector('#toast-icon');
  const messageEl = document.querySelector('#toast-message');
  if (!toast || !icon || !messageEl) return;
  toast.className = 'toast';
  const iconMap = { success: 'check_circle', error: 'error', warning: 'warning', info: 'info' };
  icon.textContent = iconMap[type] || 'info';
  messageEl.textContent = message;
  toast.classList.add(`${type}-util`, 'show');
  clearTimeout(toastTimeout);
  toastTimeout = setTimeout(() => { toast.classList.remove('show'); }, duration);
}

function showDialog(id) {
  const dialog = document.querySelector(`#${id}`);
  if (!dialog) return;
  document.querySelectorAll('.dialog.show').forEach(d => { if (d.id !== id) d.classList.remove('show'); });
  dialog.classList.add('show');
  document.body.classList.add('disabled-scroll');
}

function hideDialog(id) {
  const dialog = document.querySelector(`#${id}`);
  if (dialog && dialog.classList.contains('show')) {
    dialog.classList.remove('show');
    if (document.querySelectorAll('.dialog.show').length === 0) {
      document.body.classList.remove('disabled-scroll');
    }
  }
}

function showLightbox(src) {
  const img = document.querySelector('#lightbox-img');
  const box = document.querySelector('#lightbox');
  if (!img || !box) return;
  img.src = src;
  img.alt = 'Preview gambar';
  box.classList.add('active');
  document.body.classList.add('disabled-scroll');
}

function hideLightbox() {
  const box = document.querySelector('#lightbox');
  if (box) box.classList.remove('active');
  document.body.classList.remove('disabled-scroll');
}

function setShareUrl(url) {
  const shareUrlInput = document.querySelector('#share-url');
  if (shareUrlInput) {
    shareUrlInput.value = url;
  }
}

function showConfirmDialog(message, onConfirm) {
  const msgEl = document.querySelector('#confirm-message');
  if (msgEl) msgEl.textContent = message;
  showDialog('confirm-dialog');
  const accept = document.querySelector('#confirm-accept');
  const cancel = document.querySelector('#confirm-cancel');
  const acceptHandler = () => { hideDialog('confirm-dialog'); if (onConfirm) onConfirm(); cleanup(); };
  const cancelHandler = () => { hideDialog('confirm-dialog'); cleanup(); };
  const cleanup = () => {
    accept.removeEventListener('click', acceptHandler);
    cancel.removeEventListener('click', cancelHandler);
  };
  if (accept && cancel) {
    accept.addEventListener('click', acceptHandler);
    cancel.addEventListener('click', cancelHandler);
  }
}

export { showToast, showDialog, hideDialog, showLightbox, hideLightbox, showConfirmDialog, setShareUrl };
